import { FC } from 'react';
import { PushPinIcon, SystemSoftwareDownloadQuickReference } from '../../assets/Icons';

export interface QuickReferenceIconProps {
    size: number;
    color?: string;
}

// publicationType must match a docs.document_type.name exactly; it is sent as-is.
export const QUICK_REFERENCE_TABS = [
    {
        publicationType: 'SOFTWARE_UPDATE',
        label: 'File Updates "Software Download"',
        Icon: SystemSoftwareDownloadQuickReference as FC<QuickReferenceIconProps>,
    },
    {
        publicationType: 'TECHNICAL_SERVICE_BULLETIN',
        label: 'Technical Service Bulletins (TSBs)',
        Icon: PushPinIcon as FC<QuickReferenceIconProps>,
    },
] as const;

export type QuickReferenceTab = (typeof QUICK_REFERENCE_TABS)[number];

export type QuickReferencePublicationType = QuickReferenceTab['publicationType'];
